import type { ReactNode } from 'react';
import { cn } from './cn';

interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-dashed border-border bg-surface p-7 text-center',
        className
      )}
    >
      <h2 className="text-h3 text-text">{title}</h2>
      {description && <p className="mx-auto mt-2 max-w-md text-body text-text-2">{description}</p>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
}

interface ErrorStateProps {
  title: string;
  happened: string;
  doing?: string;
  youCan?: string;
  actions?: ReactNode;
  className?: string;
}

export function ErrorState({ title, happened, doing, youCan, actions, className }: ErrorStateProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-border border-l-[3px] border-l-danger bg-surface p-5',
        className
      )}
      role="alert"
    >
      <h2 className="text-h3 text-text">{title}</h2>
      <dl className="mt-3 space-y-2 text-sm text-text-2">
        <div>
          <dt className="inline font-semibold text-text">What happened · </dt>
          <dd className="inline">{happened}</dd>
        </div>
        {doing && (
          <div>
            <dt className="inline font-semibold text-text">What we&apos;re doing · </dt>
            <dd className="inline">{doing}</dd>
          </div>
        )}
        {youCan && (
          <div>
            <dt className="inline font-semibold text-text">What you can do · </dt>
            <dd className="inline">{youCan}</dd>
          </div>
        )}
      </dl>
      {actions && <div className="mt-4 flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}
